/* eslint-disable import/no-anonymous-default-export */
import { UPDATE_APP_DATA } from "../actionTypes/app";

const localStorageData = JSON.parse(sessionStorage.getItem("AppData")) || {};
const initialState = { ...localStorageData };

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_APP_DATA: {
      const { data, saveToLocalStorage = false, clearAll = false } = action;
      if (saveToLocalStorage) {
        sessionStorage.setItem(
          "AppData",
          JSON.stringify({ ...state, ...data })
        );
      }

      if (clearAll) return {};
      return { ...state, ...data };
    }
    default:
      return state;
  }
}
